import { PeriodProvider } from "@/providers/Period";
import { FaDoorOpen } from "react-icons/fa";
import AcompanhamentoDemanda from "./Demanda";
import ModalDemanda from "./Demanda/children/Form";
import AcompanhamentoContratacao from "./AcompanhamentoDePortariaContratacao";
import ModalContratacao from "./AcompanhamentoDePortariaContratacao/children/Form";
import Contratacao from "./Contratacao";
import ModalComentario from "./AcompanhamentoDePortariaContratacao/children/Comentario";
import AcompanhamentoAgendamento from "./AcompanhamentoDePortariaAgendamento";
import FilterCarga from "./AcompanhamentoDePortariaAgendamento/children/Form";
import ObsCarga from "./AcompanhamentoDePortariaAgendamento/children/ObsCarga";
import ModalVeiculo from "./AcompanhamentoDePortariaAgendamento/children/Veiculos";
import ControleLeadTime from "./ControleLeadTime";
import FilaDeCarga from "./FilaDeCarga";
import PainelChamadaAlerta from "./PainelChamadaAlerta";



const ModuleAcompanhamentoPortaria = {
  menuItem: {
    to: "/acompanhamento_portaria",
    title: "Acomp. Portaria",
    icon: FaDoorOpen ,
    id: 930,
    childrens: [
      {
        to: "/acompanhamento-portaria/demanda",
        title: "Demanda",
        fullTitle: "Demanda",
        id: 50,
      },
      {
        to: "/acompanhamento-portaria/contratacao",
        title: "Contratação",
        fullTitle: "Contratação",
        id: 50,
      },
      {
        to: "/acompanhamento-portaria/acompanhamento-contratacao",
        title: "Acompanhamento de Portaria - Contratação",
        fullTitle: "Acompanhamento de Portaria - Contratação",
        id: 50,
      },
      {
        to: "/acompanhamento-portaria/agendamento",
        title: "Agendamento",
        fullTitle: "Agendamento",
        id: 50,
      },
      {
        to: "/acompanhamento-portaria/controle-lead-time",
        title: "Controle Lead Time",
        fullTitle: "Controle Lead Time",
        id: 50,
      },
      {
        to: "/acompanhamento-portaria/fila-de-carga",
        title: "Portaria Fila de Carga",
        fullTitle: "Portaria Fila de Carga",
        id: 50,
      },
      {
        to: "/acompanhamento-portaria/painel-chamada-alerta",
        title: "Painel Chamada",
        fullTitle: "Painel Chamada",
        id: 50,
      },
      
    ],
  },

  routes: [
    {
      path: "/acompanhamento-portaria/demanda",
      element:<PeriodProvider> <AcompanhamentoDemanda /></PeriodProvider>,
      children: [
        { path: ':id', element: <ModalDemanda/> },
        { path: 'novo', element: <ModalDemanda /> },
      ],
    },
    {
      path: "/acompanhamento-portaria/contratacao",
      element:<PeriodProvider> <Contratacao /></PeriodProvider>,
      children: [
        { path: ':id', element: <ModalDemanda/> },
        { path: 'novo', element: <ModalDemanda /> },
      ],
    },
    {
      path: "/acompanhamento-portaria/acompanhamento-contratacao",
      element:<PeriodProvider> <AcompanhamentoContratacao /></PeriodProvider>,
      children: [
        { path: ':id', element: <ModalContratacao/> },
        { path: 'novo', element: <ModalContratacao /> },
        { path: 'comentario/:id', element: <ModalComentario /> },
      ],
    },
        {
      path: "/acompanhamento-portaria/agendamento",
      element:<PeriodProvider> <AcompanhamentoAgendamento /></PeriodProvider>,
      children: [
        { path: ':id', element: <ModalContratacao/> },
        { path: 'novo', element: <ModalVeiculo /> },
        { path: 'obscarga', element: <ObsCarga /> },
        { path: 'comentario/:id', element: <ModalComentario /> },
      ],
    },
  {
      path: "/acompanhamento-portaria/controle-lead-time",
      element:<PeriodProvider> <ControleLeadTime /></PeriodProvider>,
    },
    {
      path: "/acompanhamento-portaria/fila-de-carga",
      element:<FilaDeCarga />,
    },
    {
      path: "/acompanhamento-portaria/painel-chamada-alerta",
      element:<PainelChamadaAlerta />,
    },
  
    
  ],
};

export default ModuleAcompanhamentoPortaria;
